import type { IntegrationStatus, Severity } from "../../shared/types";

export const statusLabels: Record<IntegrationStatus, string> = {
  SCHEDULED: "Scheduled",
  RUNNING: "Running",
  SUCCEEDED: "Healthy",
  FAILED: "Failed",
  CANCELLED: "Cancelled",
  MISSING: "Missing",
  LATE: "Late",
  LONG_RUNNING: "Long Running",
  UNKNOWN: "Unknown"
};

export const severityRank: Record<Severity, number> = {
  LOW: 1,
  MEDIUM: 2,
  HIGH: 3,
  CRITICAL: 4
};

export const statusTone: Record<IntegrationStatus, string> = {
  SCHEDULED: "scheduled",
  RUNNING: "running",
  SUCCEEDED: "healthy",
  FAILED: "failed",
  CANCELLED: "cancelled",
  MISSING: "missing",
  LATE: "late",
  LONG_RUNNING: "long-running",
  UNKNOWN: "unknown"
};

export function formatDateTime(value?: string): string {
  if (!value) {
    return "-";
  }

  return new Intl.DateTimeFormat("en", {
    month: "short",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit"
  }).format(new Date(value));
}

export function formatDuration(minutes?: number): string {
  if (minutes === undefined) {
    return "-";
  }

  if (minutes < 60) {
    return `${minutes}m`;
  }

  const hours = Math.floor(minutes / 60);
  const remaining = minutes % 60;
  return `${hours}h ${remaining}m`;
}

export function getStatusSummary(status: IntegrationStatus): string {
  switch (status) {
    case "SUCCEEDED":
      return "Within expected operating window";
    case "RUNNING":
      return "Actively processing";
    case "FAILED":
      return "Requires operator review";
    case "MISSING":
      return "No run detected after grace";
    case "LATE":
      return "Started after grace period";
    case "LONG_RUNNING":
      return "Exceeded duration threshold";
    case "CANCELLED":
      return "Stopped before completion";
    case "SCHEDULED":
      return "Waiting for expected start";
    default:
      return "Needs classification";
  }
}
